import { InlineLoading, RadioTile, TileGroup } from '@carbon/react';
import styles from './grid-surface-list.module.scss';
import { StructureGridQueryResponse } from 'types/api-responses';
import { format } from 'date-fns';
import { EmptyState } from 'components/empty-state';
import NoDataSvg from 'images/srp-illustration-data.svg';
import { isNil } from 'lodash-es';

interface GridSurfaceListProps {
  selectedGridSurfaceId?: number;
  onSelectGridSurface: (gridSurface?: StructureGridQueryResponse) => void;
  gridSurfaces: StructureGridQueryResponse[] | null;
  isLoading: boolean;
}

export const GridSurfaceList = ({
  selectedGridSurfaceId,
  onSelectGridSurface,
  gridSurfaces,
  isLoading,
}: GridSurfaceListProps) => {
  if (isLoading) {
    return <InlineLoading data-testid="loading-state" />;
  }

  if (isNil(gridSurfaces) || gridSurfaces?.length === 0) {
    return (
      <div className={styles.emptyStateContainer}>
        <EmptyState
          headerText="No Data Available"
          icon={NoDataSvg}
          helperText="Currently Insights doesn’t have any surface grids."
        />
      </div>
    );
  }

  return (
    <TileGroup
      name="Grid Surface"
      valueSelected={selectedGridSurfaceId?.toString()}
      onChange={(value: string) => {
        const gridSurface = gridSurfaces?.find(
          (gridSurface) => gridSurface.id === Number(value)
        );
        onSelectGridSurface(gridSurface);
      }}
      className={styles.tileGroup}
    >
      {gridSurfaces.map((gridSurface) => (
        <RadioTile value={gridSurface.id} key={gridSurface.id}>
          <div className={styles.tileWidth}>
            <p className={styles.gridSurfaceTitle}>{gridSurface.gridSurface}</p>
            <p className={styles.gridSurfaceText}>
              <span>Owner :</span> {gridSurface.owner}
            </p>
            <p className={styles.gridSurfaceText}>
              <span>Created At :</span>
              {format(new Date(gridSurface.createdAt), 'MM/dd/yyyy')}
            </p>
            <p className={styles.gridSurfaceText}>
              <span>Source :</span> {gridSurface.source}
            </p>
          </div>
        </RadioTile>
      ))}
    </TileGroup>
  );
};
